// src/hooks/useCollectionModal.ts
"use client";

import { useState, useCallback, useRef } from "react";
import { Collection } from "@/types/timeline";

interface UseCollectionModalOptions {
    onOpen?: (collection: Collection) => void;
    onClose?: () => void;
}

export function useCollectionModal(options: UseCollectionModalOptions = {}) {
    const [selectedCollection, setSelectedCollection] = useState<Collection | null>(null);
    const [isOpen, setIsOpen] = useState(false);
    const savedScrollY = useRef<number>(0);

    const openModal = useCallback(
        (collection: Collection) => {
            savedScrollY.current = window.scrollY;
            setSelectedCollection(collection);
            setIsOpen(true);
            options.onOpen?.(collection);
        },
        [options],
    );

    const closeModal = useCallback(() => {
        setIsOpen(false);
        setSelectedCollection(null);
        options.onClose?.();
        setTimeout(() => window.scrollTo(0, savedScrollY.current), 0);
    }, [options]);

    return { selectedCollection, isOpen, openModal, closeModal };
}